// Subpath import on purpose: this module is on the eagerly loaded bootstrap path, and pulling
// GAME_VERSION through a domain entry such as '@towerpower/shared/content' would drag that whole entry into the entry chunk.
import { GAME_VERSION } from '@towerpower/shared/version';

/**
 * The one build identifier every surface reports: the Settings screen shows it, the bug-report form
 * carries it, and both error reporters send it, so a tester's screenshot can be matched to the exact
 * deploy that produced it. GAME_VERSION alone cannot do that — it moves only on a release bump.
 */
const BUILD_REVISION = typeof __BUILD_REVISION__ === 'string' && __BUILD_REVISION__ !== ''
  ? __BUILD_REVISION__
  : 'dev';

export const BUILD_ID = `${GAME_VERSION}+${BUILD_REVISION}`;
